import { Core } from "@faire/design-tokens";
import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterLearnMoreFromActionModalClick } from "@faire/web-api/events/helpCenter/click/learnMoreFromActionModal";
import { trackHelpCenterViewOrderDetailsFromActionModalClick } from "@faire/web-api/events/helpCenter/click/viewOrderDetailsFromActionModal";
import { Button } from "@faire/web/slate/Button";
import { Information } from "@faire/web/slate/icons/foundation/Information";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useActionTypes } from "../hooks/useActionTypes";
import { useShowMessage } from "../hooks/useShowMessage";
import { QuickActionType } from "../types";
export var MessageInfo = function MessageInfo(_ref) {
  var selectedOption = _ref.selectedOption,
    dropdownOptions = _ref.dropdownOptions;
  var _useActionTypes = useActionTypes(),
    actionType = _useActionTypes.actionType;
  var _useShowMessage = useShowMessage(dropdownOptions, selectedOption),
    showEmptyState = _useShowMessage.showEmptyState,
    showNotShippedMessage = _useShowMessage.showNotShippedMessage,
    showBeingFulfilledMessage = _useShowMessage.showBeingFulfilledMessage,
    showNeedExtensionMessage = _useShowMessage.showNeedExtensionMessage,
    redirectLink = _useShowMessage.redirectLink;
  if (showEmptyState) {
    if ((actionType === null || actionType === void 0 ? void 0 : actionType.id) === QuickActionType.RETURN_ITEMS) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
        height: "1x"
      }), /*#__PURE__*/React.createElement(Row, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Information, null), /*#__PURE__*/React.createElement(Spacer, {
        width: "1x"
      }), /*#__PURE__*/React.createElement(Typography, {
        color: Core.text.subdued
      }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
        id: "OibVXZ",
        defaultMessage: [{
          "type": 0,
          "value": "Het lijkt erop dat je geen bestellingen hebt om te retourneren."
        }]
      }))));
    }
    if ((actionType === null || actionType === void 0 ? void 0 : actionType.id) === QuickActionType.CANCEL_AN_ORDER) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
        height: "1x"
      }), /*#__PURE__*/React.createElement(Row, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Information, null), /*#__PURE__*/React.createElement(Spacer, {
        width: "1x"
      }), /*#__PURE__*/React.createElement(Typography, {
        color: Core.text.subdued
      }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
        id: "WeAvul",
        defaultMessage: [{
          "type": 0,
          "value": "Het lijkt erop dat je geen bestellingen hebt die kunnen worden geannuleerd."
        }]
      }))));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Row, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Information, null), /*#__PURE__*/React.createElement(Spacer, {
      width: "1x"
    }), /*#__PURE__*/React.createElement(Typography, {
      color: Core.text.subdued
    }, isRetailer() ? ( /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "c4KcTb",
      defaultMessage: [{
        "type": 0,
        "value": "Het lijkt erop dat je nog geen bestellingen hebt geplaatst."
      }]
    })) : ( /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "q0g8eW",
      defaultMessage: [{
        "type": 0,
        "value": "Het lijkt erop dat je nog geen bestellingen hebt ontvangen."
      }]
    })))));
  }
  if (showNotShippedMessage) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Row, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Information, null), /*#__PURE__*/React.createElement(Spacer, {
      width: "1x"
    }), /*#__PURE__*/React.createElement(Typography, {
      color: Core.text.subdued
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "4xe8py",
      defaultMessage: [{
        "type": 0,
        "value": "Deze bestelling is nog niet verzonden. "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestelgegevens bekijken"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return ViewOrderDetailsFormatting(chunks, redirectLink, actionType);
        }
      }
    }))));
  }
  if (showBeingFulfilledMessage) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Row, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Information, null), /*#__PURE__*/React.createElement(Spacer, {
      width: "1x"
    }), /*#__PURE__*/React.createElement(Typography, {
      color: Core.text.subdued
    }, " ", /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "hInyc0",
      defaultMessage: [{
        "type": 0,
        "value": "Deze bestelling wordt uitgevoerd, maar je kunt nog steeds rechtstreeks een annulering van het merk aanvragen. "
      }, {
        "children": [{
          "type": 0,
          "value": "Meer informatie"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return LearnMoreLinkFormatting(chunks, redirectLink, actionType);
        }
      }
    }))));
  }
  if (showNeedExtensionMessage) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Row, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Information, null), /*#__PURE__*/React.createElement(Spacer, {
      width: "1x"
    }), /*#__PURE__*/React.createElement(Typography, {
      color: Core.text.subdued
    }, " ", /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "RrsAc2",
      defaultMessage: [{
        "type": 0,
        "value": "Deze bestelling is voorbij ons 14-dagenbeleid om beschadigde of ontbrekende artikelen te melden. "
      }, {
        "children": [{
          "type": 0,
          "value": "Meer informatie"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return LearnMoreLinkFormatting(chunks, redirectLink, actionType);
        }
      }
    }))));
  }
  return null;
};
var LearnMoreLinkFormatting = function LearnMoreLinkFormatting(chunks, redirectLink, actionType) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: redirectLink,
    onClick: function onClick() {
      var _actionType$label;
      return trackHelpCenterLearnMoreFromActionModalClick((_actionType$label = actionType === null || actionType === void 0 ? void 0 : actionType.label) !== null && _actionType$label !== void 0 ? _actionType$label : "");
    }
  }, chunks);
};
var ViewOrderDetailsFormatting = function ViewOrderDetailsFormatting(chunks, redirectLink, actionType) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: redirectLink,
    onClick: function onClick() {
      var _actionType$label2;
      return trackHelpCenterViewOrderDetailsFromActionModalClick((_actionType$label2 = actionType === null || actionType === void 0 ? void 0 : actionType.label) !== null && _actionType$label2 !== void 0 ? _actionType$label2 : "");
    }
  }, chunks);
};